import React, { useEffect, useState } from 'react'
import styles from './style/button_style.module.scss';
import PropTypes from 'prop-types';
import Typography from '../../foundations/typography/Typography'
import Icon, { ICON_PROPTYPES, IconMap } from '../../foundations/icon/Icon'
import HarveyIcon from '../harvey-icon/HarveyIcon'

const DEFAULT_TYPEFACE = 'body-s-regular'
const DEFAULT_SMALL_TYPEFACE = 'body-xs-regular'
const DEFAULT_ICON_SIZE = "24"

const Button = ({ children, onClick, className = '', gtmLabel, ...props }) => {
    const [buttonClasses, setButtonClasses] = useState('')
    const [isOver, setIsOver] = useState(false)

    const IconImage = props.hImg ?
        <HarveyIcon harveyImg={props.img} dentImg={props.hImg} size={props.iconSize} face={isOver ? 'dent' : 'harvey'} {...props} />
        :
        <Icon img={props.img} size={props.iconSize}/>

    useEffect(() => {
        const _styles = []
        Object.keys(props).forEach(key => {
            if (BUTTON_PROPTYPES[key]) {
                if (key !== 'typeface') _styles.push(styles[key])
            }
        })
        setButtonClasses(_styles.join(' '))
    }, []);

    const switchIcon = over => {
        if (over && props.hImg && !props.disabled) setIsOver(true)
        else if (props.img) setIsOver(false)
    }

    return (
        <div className={`${styles.button} ${buttonClasses} ${className}`}
             onMouseEnter={() => switchIcon(true)}
             onMouseLeave={() => switchIcon(false)}
             onClick={props.disabled ? undefined : onClick}
             gtm-label={gtmLabel}
        >
            <Typography typeface={props['size-s'] ? DEFAULT_SMALL_TYPEFACE : DEFAULT_TYPEFACE} {...props}>
                {children}
            </Typography>
            {IconImage}
        </div>
    );
};

const BUTTON_PROPTYPES = {
    'size-s': PropTypes.bool,
    'size-m': PropTypes.bool,
    'size-l': PropTypes.bool,
    'size-fill': PropTypes.bool,
    'reverse': PropTypes.bool,
    'style-black': PropTypes.bool,
    'style-white': PropTypes.bool,
    'style-hero': PropTypes.bool,
    'style-link': PropTypes.bool,
    'style-dark': PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    img: ICON_PROPTYPES.img,
    hImg: PropTypes.oneOf(Object.keys(IconMap)),
    iconSize: PropTypes.string
}

Button.propTypes = BUTTON_PROPTYPES

Button.defaultProps = {
    iconSize: DEFAULT_ICON_SIZE
}

export default Button;
